import { FC, useMemo } from "react";
import cn from "classnames";
import { ShipmentModel } from "features/shared/shipmentCard.types";
import { isAirSearchCardModel } from "entities/AirSearchCard";
import { appStore } from "entities/App";
import { authStore } from "entities/Auth";
import { useMobile } from "shared/hooks/useMobile.hook";
import { useAppSelector } from "shared/lib/redux";
import { useTranslation } from "shared/localization/localization";
// import { Button } from "shared/ui/Button";
import styles from "./AirDemoModeBanner.module.scss";

type AirDemoModeBannerProps = {
  openedCard: ShipmentModel | null;
};

export const AirDemoModeBanner: FC<AirDemoModeBannerProps> = ({ openedCard }) => {
  const { t } = useTranslation();
  // const dispatch = useAppDispatch();

  const { isMobile } = useMobile();
  const isPanelVisible = useAppSelector(appStore.selectors.isPanelVisible);
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);

  const message = useMemo(() => {
    if (!openedCard && isAuthenticated) return null;
    if (isAirSearchCardModel(openedCard) && openedCard.cacheComment) {
      return openedCard.cacheComment;
    }
    return null;
  }, [openedCard?.reference, isAuthenticated]);

  if (!message) return null;

  return (
    <div className={cn(styles.demoModBannerWrapper, { [styles.shouldHideOnPanel]: isPanelVisible && isMobile })}>
      <div className={styles.demoModBanner}>
        <b>{t(message)}</b> {t("To see positions in real-time, please")}{" "}
        {/* User login CTA disabled.
        <Button className={styles.link} onClick={() => dispatch(authStore.actions.setIsAuthModalVisibleAction(true))}>
          {t("log in")}
        </Button>{" "}
        */}
        <span>{t("log in")}</span>{" "}
      </div>
    </div>
  );
};
